// extracted by mini-css-extract-plugin
export default {"header":"ScrollTable_header__KiGJT","scrolled":"ScrollTable_scrolled__AN1xe"};